module.exports = __webpack_public_path__ + "fonts/smartcommerce-iconfont.85b272ef.woff";